import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoItsFor() {
  return <section className="py-24 px-6 max-w-4xl mx-auto" data-id="element-228">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} data-id="element-229">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-230">
          {/* For You */}
          <div className="bg-sage/10 p-8 rounded-2xl border border-sage/20" data-id="element-231">
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-232">
              <CheckCircle2 className="w-6 h-6 text-sage" data-id="element-233" />
              This is for you if:
            </h3>
            <ul className="space-y-4" data-id="element-234">
              {["You're a solo mom and the house feels like sensory overload", "You're tired of yelling and then hating yourself afterward", 'You want a plan that works on "bad days"', 'You want calm without spending money on more stuff'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-235">
                  <span className="w-1.5 h-1.5 rounded-full bg-sage mt-2 shrink-0" data-id="element-236" />
                  <span data-id="element-237">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-terracotta/5 p-8 rounded-2xl border border-terracotta/10" data-id="element-238">
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-239">
              <XCircle className="w-6 h-6 text-terracotta" data-id="element-240" />
              This isn't for you if:
            </h3>
            <ul className="space-y-4" data-id="element-241">
              {['You want a strict discipline program', 'You want a home makeover', "You're looking for therapy inside a PDF"].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-242">
                  <span className="w-1.5 h-1.5 rounded-full bg-terracotta mt-2 shrink-0" data-id="element-243" />
                  <span data-id="element-244">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </motion.div>
    </section>;
}